// extracted by mini-css-extract-plugin
export default {"ExpandedPostModal":"styles_ExpandedPostModal__hhuqD","closeBtn":"styles_closeBtn__lFgQz"};